import api from './config';

export const changePassword = async (currentPassword, newPassword) => {
    try {
        const token = localStorage.getItem('token');
        if (!token) {
            throw new Error('No authentication token found');
        }

        await api.post('/user/settings/change-password', {
            current_password: currentPassword,
            new_password: newPassword
        }, {
            headers: {
                'Authorization': `Bearer ${atob(token)}`
            }
        });
    } catch (error) {
        throw error.response?.data || 'Failed to change password';
    }
};

export const getProfile = async () => {
    try {
        const token = localStorage.getItem('token');
        if (!token) {
            throw new Error('No authentication token found');
        }

        const response = await api.get('/user/profile', {
            headers: {
                'Authorization': `Bearer ${atob(token)}`
            }
        });
        return response.data;
    } catch (error) {
        throw error.response?.data || 'Failed to fetch profile';
    }
};

export const updateProfile = async (name) => {
    try {
        const token = localStorage.getItem('token');
        if (!token) {
            throw new Error('No authentication token found');
        }

        await api.patch('/user/profile', {
            name: name
        }, {
            headers: {
                'Authorization': `Bearer ${atob(token)}`
            }
        });
    } catch (error) {
        throw error.response?.data || 'Failed to update profile';
    }
};

export const getUser = async () => {
    try {
        const token = localStorage.getItem('token');
        if (!token) {
            throw new Error('No authentication token found');
        }

        const response = await api.get('/user/profile', {
            headers: {
                'Authorization': `Bearer ${atob(token)}`
            }
        });
        return response.data;
    } catch (error) {
        throw error.response?.data || 'Failed to fetch profile';
    }
};

export const updateUser = async (userData) => {
    try {
        const token = localStorage.getItem('token');
        if (!token) {
            throw new Error('No authentication token found');
        }

        await api.patch('/user/profile', {
            name: userData.name
        }, {
            headers: {
                'Authorization': `Bearer ${atob(token)}`
            }
        });
    } catch (error) {
        throw error.response?.data || 'Failed to update profile';
    }
};

export const updatePassword = async (passwordData) => {
    try {
        const token = localStorage.getItem('token');
        if (!token) {
            throw new Error('No authentication token found');
        }

        await api.post('/user/settings/change-password', {
            current_password: passwordData.currentPassword,
            new_password: passwordData.newPassword
        }, {
            headers: {
                'Authorization': `Bearer ${atob(token)}`
            }
        });
    } catch (error) {
        throw error.response?.data || 'Failed to change password';
    }
};